import Vue from 'vue'
import Vuex from 'vuex'
import { fetch } from './api/index'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        configData: {}
    },
    mutations: {
        getConfig(state, payload) {
            state.configData = payload
        }
    },
    actions: {
        // getEnum
        getSiteInfo({ commit, state }) {
            return new Promise(async (resolve, reject) => {
                const data = await fetch('/getSiteInfo', {})
                if (data && data.data) {
                    commit('getConfig', data.data.data)
                    resolve(data.data.data)
                } else {
                    reject('error')
                }
            })
        }
    }
})
